export default {
  id: "heart-world-wave-breaker",
  pride: 24576,
  slug: "heart-world-wave-breaker",
  series: "heart-world",
  category: ["video", "blog"],
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "【心界/tulpa小故事】破浪者",
    en: "[Heart World/Tulpa] Wave Breaker"
  },
  bilibiliVideoId: "BV1au9XBvEa1",
  descriptionKey: {
    zh: "心界 tulpa 动画短片。导演/分镜：Deepseek-V4-pro，画面生成：Seedance 2.0。战斗爽！",
    en: "Heart World tulpa animated short. Directing/storyboard: Deepseek-V4-pro. Animation: Seedance 2.0. Pure action fun!"
  },
  date: { year: 2026, month: 5, day: 3 },
  genres: ["OC动画", "AI动画"],
  themes: ["心界", "tulpa", "战斗"],
  developerNotesKey: {
    zh: "剧本：最近发生的事。导演/分镜/运镜设计：Deepseek-V4-pro。画面生成与动画渲染：Seedance 2.0。参与人物（按出现顺序）：于启、银、萝北、柿子（tulpa），刹那、公理（未确定外来者），缪斯（潜意识）。",
    en: "Script: recent events. Director/storyboard/cinematography: Deepseek-V4-pro. Animation rendering: Seedance 2.0. Cast in order of appearance: Yuqi, Yin, Luobei, Kaki (tulpas); Chana, Axiom (unconfirmed outsiders); Muse (subconscious)."
  },
  tags: ["心界", "AI动画"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1au9XBvEa1/", textKey: { zh: "B站观看", en: "Watch on Bilibili" } }
  ]
};
